import { useCallback } from "react";
import axios from "axios";
import { InboxActionData, InboxActionLog } from "@hilos/types/inbox_action";
import { API_ROUTES, buildAPIRoute } from "../router/router";

interface ExecuteActionOptions {
  variablesProcessed?: boolean;
  requestUrl?: string;
  requestBody?: string | Record<string, string> | null;
  requestHeaders?: Record<string, string>;
  requestParams?: Record<string, string>;
}

function useInboxActionDetails() {
  const executeAction = useCallback(
    async (
      contactId: string, 
      action: InboxActionData, 
      options?: ExecuteActionOptions
    ) => {
      const payload = options?.variablesProcessed 
        ? {
            variables_processed: true,
            request_url: options.requestUrl,
            request_body: options.requestBody,
            request_headers: options.requestHeaders,
            request_params: options.requestParams,
          }
        : {};

      const { data } = await axios.post<InboxActionLog>(
        buildAPIRoute(API_ROUTES.INBOX_ACTION_RUN, {
          ":id": action.id,
          ":contact": contactId,
        }),
        payload
      );
      return data;
    },
    []
  );

  return {
    executeAction,
  };
}

export default useInboxActionDetails;
